module.exports = __webpack_public_path__ + "static/media/rutes_i_visites.25f6b3eb.jpg";